import { FC, Fragment, useEffect, useRef } from "react";
import useAppSelector from "hooks/useAppSelector";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useState } from "react";

import zaloIcon from "utils/images/zalo-icon.png";
import facebookIcon from "utils/images/facebook-icon.png";
import emailIcon from "utils/images/email-icon.png";

interface ViewContainerProps {
}

const menus = [
    {
        label: "Trang chủ",
        url: "/"
    },
    {
        label: "Giới thiệu",
        url: "/gioi-thieu.html",
        children: [
            {
                label: "Tổng quan về bệnh viện",
                url: "/tong-quan.html"
            },
            {
                label: "Tầm nhìn, sứ mệnh",
                url: "/tam-nhin-su-menh.html"
            },
            {
                label: "Cơ cấu tổ chức",
                url: "/co-cau-to-chuc.html"
            },
        ]
    },
    {
        label: "Tin tức, sự kiên",
        url: "/tin-tuc.html"
    },
    {
        label: "Bảng giá dịch vụ",
        url: "/dich-vu.html"
    },
    {
        label: "Liên hệ",
        url: "/lien-he.html"
    },
]
const ViewContainer: FC<ViewContainerProps> = ({ }) => {
    const { logoUrl, title, copyright, address, email, phone, linkEmail, linkFacebook, linkZalo } = useAppSelector(state => state.config);
    const menuMobileRef = useRef<HTMLDivElement>(null);
    const btnMobileRef = useRef<HTMLButtonElement>(null);
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (
                menuMobileRef.current &&
                !menuMobileRef.current.contains(event.target as Node) &&
                btnMobileRef.current &&
                !btnMobileRef.current.contains(event.target as Node)
            ) {
                menuMobileRef.current.classList.add("hidden");
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <Fragment>
            <div className="view-container flex flex-col min-h-screen">
                <header className="bg-white shadow-md fixed top-0 left-0 right-0 z-50">
                    <div className="container mx-auto px-4 flex justify-between items-center h-20">
                        {/* Logo */}
                        <div className="flex items-center">
                            <img src={logoUrl || ""} className="h-[50px] w-[50px] mr-3 text-blue-700 rounded-full shadow" />
                            <Link to="/" className="text-2xl font-bold text-gray-800">
                                {title}
                            </Link>
                        </div>
                        {/* Menu desktop */}
                        <nav className="hidden md:flex space-x-8">
                            {
                                menus.map((item, i) => {
                                    if (item.children && item.children.length > 0) {
                                        return <div className="relative group" key={i}>
                                            <button className="flex items-center text-lg text-black hover:text-blue-700 transition">
                                                {item.label}
                                                <svg
                                                    className="ml-1 w-4 h-4"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M19 9l-7 7-7-7"
                                                    />
                                                </svg>
                                            </button>
                                            <div className="absolute left-0 top-full hidden group-hover:block bg-white shadow-lg rounded w-60 py-2 transition-opacity duration-200 opacity-0 group-hover:opacity-100">
                                                {item.children.map((chil, j) => {
                                                    return <Link
                                                        key={j}
                                                        to={chil.url}
                                                        className="text-lg block px-4 py-2 hover:bg-gray-100"
                                                    >
                                                        {chil.label}
                                                    </Link>
                                                })}
                                            </div>
                                        </div>
                                    }
                                    else {
                                        return <Link to={item.url} className="text-lg text-black hover:text-blue-700 transition" key={i}>
                                            {item.label}
                                        </Link>


                                    }
                                })
                            }
                        </nav>
                        {/* Nút đặt lịch desktop */}
                        <Link
                            to="/dat-hen.html"
                            className="hidden md:inline-block bg-blue-700 text-white px-5 py-2 rounded-full hover:bg-blue-800 transition"
                        >
                            Đặt lịch khám Online
                        </Link>
                        {/* Nút mobile */}
                        <button
                            className="md:hidden"
                            onClick={() => {
                                document.getElementById("mobile-menu")?.classList.toggle("hidden");
                            }}
                            ref={btnMobileRef}
                        >
                            <svg
                                className="w-8 h-8 text-gray-700"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M4 6h16M4 12h16M4 18h16"
                                />
                            </svg>
                        </button>
                    </div>
                    {/* Menu mobile */}
                    <div id="mobile-menu" className="hidden md:hidden bg-white shadow-lg pb-4" ref={menuMobileRef}>
                        {
                            menus.map((item, i) => {
                                if (item.children && item.children.length > 0) {
                                    return <div>
                                        <button
                                            className="w-full text-left px-4 py-2 hover:bg-gray-100 flex justify-between items-center"
                                            onClick={() => {
                                                document.getElementById(`mobile-submenu-${i}`)?.classList.toggle('hidden');
                                            }}
                                        >
                                            {item.label}
                                            <svg
                                                className="w-4 h-4"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M19 9l-7 7-7-7"
                                                />
                                            </svg>
                                        </button>
                                        <div id={`mobile-submenu-${i}`} className="hidden pl-6">
                                            {item.children.map((chil, j) => {
                                                return <Link
                                                    onClick={() => document.getElementById("mobile-menu")?.classList.add("hidden")}
                                                    to={chil.url}
                                                    className="block px-4 py-2 hover:bg-gray-100"
                                                    key={j}
                                                >
                                                    {chil.label}
                                                </Link>
                                            })}
                                        </div>
                                    </div>
                                }
                                else {
                                    return <Link
                                        to={item.url}
                                        className="block px-4 py-2 hover:bg-gray-100"
                                        onClick={() => document.getElementById("mobile-menu")?.classList.add("hidden")}
                                    >
                                        {item.label}
                                    </Link>
                                }
                            })
                        }
                        <Link
                            onClick={() => document.getElementById("mobile-menu")?.classList.add("hidden")}
                            to="/dat-hen.html"
                            className="block bg-blue-700 text-white px-4 py-2 mx-4 rounded-full text-center hover:bg-blue-800 transition"
                        >
                            Đặt lịch khám Online
                        </Link>
                    </div>
                </header>
                <main className="flex-grow pt-20 bg-gray-100">
                    <Outlet />
                </main>
                <footer className="bg-gray-800 text-white py-10">
                    <div className="container mx-auto px-4 py-8">
                        <div className="container grid grid-cols-1 md:grid-cols-3 gap-8">
                            {/* About Us */}
                            <div>
                                <h4 className="text-xl font-bold mb-4 text-primary">Về Bệnh viện</h4>
                                <p className="text-secondary">
                                    Bệnh viện Đa khoa khu vực Hướng Hoá cam kết mang đến dịch vụ y tế chất
                                    lượng cao, vì sức khỏe và hạnh phúc của mọi người.
                                </p>
                            </div>
                            {/* Quick Links */}
                            <div>
                                <h4 className="text-xl font-bold mb-4 text-primary">
                                    Liên kết nhanh
                                </h4>
                                <ul className="space-y-2">
                                    {menus.map((item, i) => {
                                        return <li key={i}>
                                            <Link
                                                to={item.url}
                                                className="text-secondary hover:text-primary transition-colors duration-300"
                                            >
                                                {item.label}
                                            </Link>
                                        </li>
                                    })}
                                    <li>
                                        <Link
                                            to="/dat-hen.html"
                                            className="text-secondary hover:text-primary transition-colors duration-300"
                                        >
                                            Đặt lịch khám Online
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            {/* Contact Info */}
                            <div>
                                <h4 className="text-xl font-bold mb-4 text-primary">Liên hệ</h4>
                                <p className="text-secondary mb-2">Địa chỉ: {address}</p>
                                <p className="text-secondary mb-2">Điện thoại: {phone}</p>
                                <p className="text-secondary mb-2">Email: {email}</p>
                                <div className="flex space-x-3">
                                    {/* Facebook */}
                                    {linkFacebook && <a
                                        href={linkFacebook}
                                        target="_blank"
                                        className="w-10 h-10 flex items-center justify-center bg-gray-700 rounded-full hover:bg-blue-800 transition-colors"
                                    >
                                        <img src={facebookIcon} className="w-5 h-5" />
                                    </a>}
                                    {/* Gmail */}
                                    {linkEmail && <a
                                        href={linkEmail}
                                        className="w-10 h-10 flex items-center justify-center bg-gray-700 rounded-full hover:bg-red-500 transition-colors"
                                    >

                                        <img src={emailIcon} className="w-5 h-5" />
                                    </a>}
                                    {/* Zalo */}
                                    {linkZalo && <a
                                        href={linkZalo}
                                        target="_blank"
                                        className="w-10 h-10 flex items-center justify-center bg-gray-700 rounded-full hover:bg-blue-400 transition-colors"
                                    >
                                        <img src={zaloIcon} className="w-5 h-5" />
                                    </a>}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-center text-secondary text-sm mt-8 pt-8 border-t border-default">
                        <div className="container mx-auto">
                            {copyright}
                        </div>
                    </div>
                </footer>
            </div>
            {/* <BackToTop /> */}
        </Fragment>
    );
};
export default ViewContainer;


function BackToTop() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setVisible(true);
            } else {
                setVisible(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <>
            {visible && (
                <button
                    onClick={scrollToTop}
                    style={{
                        position: "fixed",
                        bottom: "30px",
                        right: "30px",
                        padding: "10px 15px",
                        borderRadius: "50%",
                        border: "none",
                        background: "#2563eb",
                        color: "white",
                        fontSize: "20px",
                        cursor: "pointer",
                        boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
                    }}
                >
                    ↑
                </button>
            )}
        </>
    );
}
